pageDetailHandler = {
  $carouselMain:  $('.carousel-main'),
  $carouselNav:   $('.carousel-nav'),
  $zoomImageContainer: $('.zoom-image-container'),
  $copyLink:      $('[href="#copy-link"]'),
  $mainImage:     $('.main-image'),
   
  init: function() {
    var self = this;

    var $carousel = this.$carouselMain.flickity({
      prevNextButtons: false,
      draggable: false,
      pageDots: false,
    });

    var $carouselNav = this.$carouselNav.flickity({
      asNavFor: ".carousel-main", 
      contain: true, 
      pageDots: false,
      prevNextButtons: false,
    });

    self.$zoomImageContainer.zoom({
      magnify: 2,
    });
    
    self.$copyLink.on('click', function(e) {
      e.preventDefault();
      navigator.clipboard.writeText(window.location.href);
      let $tooltip = $(this).find('.tooltip');
      $tooltip.addClass('active');
      setTimeout(() => {
        $tooltip.removeClass('active');
      }, 1000);
    })

    if (self.$mainImage.length > 0) {
      var src = self.$mainImage.prop('src');
      if (src.indexOf('/image-not-found.png') > -1) {
        self.$mainImage.closest('.cell-img-container').addClass('disabled')
      }
    }

    $('.carousel-main .main-image').on('focus', function() {
      $(this).closest('.carousel-cell').addClass('focused');
    }).on('blur', function() {
      $(this).closest('.carousel-cell').removeClass('focused');
    }).on('keydown', function(e) {
      if (e.key === 'Enter') {
        $(this).trigger('click')
      }
    });
    
    $('.icon-magnifier[data-open]').removeAttr('tabindex')

    self.setBackLink();
  },

  /**
   * Point the BACK link at the collection list the visitor came from.
   *
   * The markup ships a plain /collection link (a clean list); document.referrer is the exact URL the
   * poster was opened from (also for a new tab opened from the collection) and sessionStorage covers
   * a stripped referrer. Anything else — direct URL, bookmark, external link, landing page, A–Z list —
   * keeps the clean fallback instead of a history.back() to a non-collection page.
   */
  setBackLink: function() {
    var self = this;
    var $back = $('.back-index-button');

    if ($back.length == 0) return;

    var $fallback = $('<a>').attr('href', $back.attr('href') || '/collection');
    var referrer  = self.getCollectionUrl(document.referrer, $fallback);

    if (referrer) {
      $back.attr('href', referrer);
      return;
    }

    var stored = '';

    try {
      stored = window.sessionStorage.getItem('phemuseum_collection_url') || '';
    } catch (e) {
      stored = '';
    }

    var $stored = self.getCollectionUrl(stored, $fallback);

    if ($stored) $back.attr('href', $stored);
  },

  /**
   * Return the collection URL to go back to, or '' when the candidate is not the collection page
   * (same origin + same path as the BACK link's fallback).
   */
  getCollectionUrl: function(url, $fallback) {
    if (!url) return '';

    var $candidate = $('<a>').attr('href', url);

    if ($candidate.prop('origin') !== $fallback.prop('origin')) return '';

    // /collection and /collection/ are the same page.
    if ($candidate.prop('pathname').replace(/\/+$/, '') !== $fallback.prop('pathname').replace(/\/+$/, '')) return '';

    return url;
  }
}